export const Schemes = [
  { text: 'Privatif (3 coins)', value: 'PRI' },
  { text: 'Mastercard', value: 'MCI' },
  { text: 'Cartes Bancaires', value: 'CBC' }
]
